import { useEffect, useRef, useState, useCallback } from 'react';
import axios from 'axios';

/**
 * Debounced POST to an authoritative engine endpoint.
 * The browser never computes these results itself — scenario, sensitivity and
 * 3-year outlook numbers always come from the server-side cost engine.
 */
export function useEngineAnalysis(path, body, { enabled = true, delay = 400 } = {}) {
  const [state, setState] = useState({ data: null, loading: false, error: false });
  const [attempt, setAttempt] = useState(0);
  const bodyRef = useRef(body);
  bodyRef.current = body;
  const key = JSON.stringify(body);

  useEffect(() => {
    if (!enabled) return undefined;
    let cancelled = false;
    setState(prev => ({ ...prev, loading: true, error: false }));
    const timer = setTimeout(() => {
      axios.post(`/api${path}`, bodyRef.current)
        .then(res => { if (!cancelled) setState({ data: res.data, loading: false, error: false }); })
        .catch(() => { if (!cancelled) setState({ data: null, loading: false, error: true }); });
    }, delay);
    return () => { cancelled = true; clearTimeout(timer); };
  }, [path, key, enabled, delay, attempt]);

  const retry = useCallback(() => setAttempt(a => a + 1), []);
  return { ...state, retry };
}
